import { gql } from 'apollo-boost';

const createClassGQL = gql`
  mutation createClassAsync($selectedStudents: [SelectedStudents!]!) {
    createClassAsync(selectedStudents: $selectedStudents)
  }
`;

export default createClassGQL;
